if (!customElements.get("s-popup-image")) {
  customElements.define(
    "s-popup-image",
    class SectionPopupImage extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.closeButton = this.querySelector(".js-popup-image__close");
        this.overlay = this.querySelector(".js-popup-image__overlay");

        this.addEventListener("click", this.closePopup);
        this.checkPopupVisibility();

        document.addEventListener("shopify:section:select", this.handleCustomizerSectionSelected);
        document.addEventListener("shopify:section:deselect", this.handleCustomizerSectionDeselected);
      }

      disconnectedCallback() {
        if (this.timeout) {
          clearTimeout(this.timeout);
        }

        this.removeEventListener("click", this.closePopup);

        document.removeEventListener("shopify:section:select", this.handleCustomizerSectionSelected);
        document.removeEventListener("shopify:section:deselect", this.handleCustomizerSectionDeselected);
      }

      checkPopupVisibility = () => {
        const isHidden = window.localStorage.getItem("disablePopupImage") === "true" ? true : false;

        if (!isHidden) {
          this.timeout = setTimeout(() => {
            this.showPopup();
          }, +this.dataset.timer);
        }
      };

      showPopup = () => {
        this.classList.add("is-active");
      };

      closePopup = () => {
        this.classList.remove("is-active");
        window.localStorage.setItem("disablePopupImage", "true");
      };

      handleCustomizerSectionSelected = (event) => {
        const selectedSectionId = event.detail.sectionId;
        const modalId = this.dataset.id;
        if (selectedSectionId === modalId) {
          this.showPopup();
        }
      };

      handleCustomizerSectionDeselected = () => {
        this.closePopup();
      };
    }
  );
}
